import styled from 'styled-components';
// @ts-ignore
import _scss from '../../styles/_variables.scss';

export const ErrorMessage = styled.div`
  color: ${_scss.errorRed};
`;
